import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { logout } from "../redux/actions/auth.actions";
import { useNavigate } from "react-router-dom";


const PrivateRoute = (props) => {
	const { Component } = props
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { isAuthenticated } = useSelector((state) => state.authReducer);
	const [token] =useState(localStorage.getItem("token"));

	useEffect(() => {
		if (!token) { 
			dispatch(logout()) 
			navigate('/login');
		}
	}, [token, dispatch,navigate])

	return isAuthenticated && <Component />
};

export default PrivateRoute;
